// eslint-disable-next-line import/prefer-default-export
export const global = '//embed.scribblelive.com/Embed/v7.aspx?Id=2929613&ThemeId=40268'
// export const pl = '//embed.scribblelive.com/Embed/v7.aspx?Id=2869048&ThemeId=40249'
